<!--
 * @FileDescription: 添加/编辑鉴定
 * @Author: zxh
 * @Date: 2022-06-29 09:30:00
 * @LastEditors: zxh
 * @LastEditTime: 2022-06-30 15:15:11
-->

<template>
  <div>
    <!--    添加鉴定抽屉-->
    <yxt-drawer
        :title="title"
        :visible.sync="drawerVisible"
        :direction="direction"
        :size="maxWidth"
        class="yxtbiz-new-ulcd-identify"
    >
      <yxt-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="96px">
        <!-- 鉴定名称 -->
        <yxt-form-item v-if="config.name" :label="config.name.name || $t('pc_biz_appraise_appraisalName' /* 鉴定名称 */)" prop="name">
          <yxt-input v-model="ruleForm.name" autocomplete="off" :placeholder="$t('pc_biz_appraise_input_appraisalName' /* 请输入鉴定名称*/)" maxlength="200" show-word-limit />
        </yxt-form-item>
        <!-- 申请时间 -->
        <yxt-form-item v-if="config.subTime" :label="config.subTime.name || $t('pc_biz_appraise_apply_time' /*申请时间*/)" prop="times">
          <yxt-date-picker
              v-model="ruleForm.times"
              type="datetimerange"
              :range-separator="$t('pc_biz_enroll_to')"
              :start-placeholder="$t('pc_comp_datepicker_startTime')"
              :end-placeholder="$t('pc_comp_datepicker_endTime')"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="yxtbiz-appraise-date">
          </yxt-date-picker>
        </yxt-form-item>
        <!-- 鉴定说明 -->
        <yxt-form-item v-if="config.tips" :label="config.tips.name || $t('pc_biz_appraise_description' /* 鉴定说明 */)" prop="description">
          <yxt-input v-model="ruleForm.description" :rows="3" type="textarea" maxlength="2000" show-word-limit :placeholder="$t('pc_biz_appraise_input_description' /*请输入鉴定说明*/)" />
        </yxt-form-item>
        <!-- 完成标准 -->
        <yxt-form-item v-if="config.principle" :label="config.principle.name || $t('pc_biz_appraise_finish_status' /*完成标准*/)" prop="finishStandard">
          <yxt-radio-group v-model="ruleForm.finishStandard" :disabled="!!isPublished">
             <yxt-radio v-for="item in finishStandardOptions" :key="item.value" :label="item.value" class="yxtbiz-appraise-radio">{{item.label}}</yxt-radio>
          </yxt-radio-group>
        </yxt-form-item>
        <!-- 鉴定方式 -->
        <yxt-form-item v-if="config.type" :label="config.type.name || $t('pc_biz_appraise_type' /* 鉴定方式 */)" prop="appraisalType" class="yxtbiz-appraise-margin8">
          <template>
            <div class="yxtbiz-appraise-radio">
              <yxt-radio v-model="ruleForm.appraisalType" :label="0" :disabled="!!isPublished" @change="handleChangeType">
               {{$t('pc_biz_appraise_type_judge' /*判断模式*/)}}
             </yxt-radio>
             <!--              判断模式查看事例popover-->
              <yxt-popover
                placement="right"
                trigger="hover"
                popper-class="yxtbiz-appraise-popover-radio"
              >
                 <div class="yxtbiz-appraise-popover-radio-option">
                   <div v-for="index of 2" :key="index">
                     <p>{{index}}. {{index===1?$t('pc_biz_appraise_popover_clothes' /*衣装整齐，衣、帽、领带、鞋佩戴无问题*/):$t('pc_biz_appraise_popover_sop' /*按照标准SOP进行洗手*/)}}</p>
                     <yxt-radio-group v-model="appraiseExample['radio'+index]">
                       <yxt-radio :label="1">{{$t('pc_biz_appraise_type_pass' /*通过*/)}}</yxt-radio>
                       <yxt-radio :label="2">{{$t('pc_biz_appraise_type_fail' /*不通过*/)}}</yxt-radio>
                     </yxt-radio-group>
                   </div>
                 </div>
                <yxt-button type="text" slot="reference">{{$t('pc_biz_appraise_check_example' /*查看事例*/)}}</yxt-button>
              </yxt-popover>
            </div>
            <appraise-mode ref="appraiseMode" v-if="ruleForm.appraisalType===0" :data="appraiseModeData[0]" @refreshMode="handleRefreshMode" :operateType="operateType" :isPublished="isPublished"/>
            <div class="yxtbiz-appraise-radio">
              <yxt-radio v-model="ruleForm.appraisalType" :label="1" :disabled="!!isPublished" @change="handleChangeType">
               {{$t('pc_biz_appraise_type_score' /*打分模式*/)}}
             </yxt-radio>
             <!--              打分模式查看事例popover-->
              <yxt-popover
                placement="right"
                trigger="hover"
                popper-class="yxtbiz-appraise-popover-mark"
              >
                <div class="yxtbiz-appraise-popover-mark-option">
                   <div v-for="index of 2" :key="index">
                     <p>{{index}}. {{index===1?$t('pc_biz_appraise_popover_clothes' /*衣装整齐，衣、帽、领带、鞋佩戴无问题*/):$t('pc_biz_appraise_popover_sop' /*按照标准SOP进行洗手*/)}}</p>
                     <slider-bar :value="appraiseExample['mark'+index]"/>
                   </div>
                 </div>
                <yxt-button type="text" slot="reference">{{$t('pc_biz_appraise_check_example' /*查看事例*/)}}</yxt-button>
              </yxt-popover>
            </div>
            <appraise-mode ref="appraiseMode" v-if="ruleForm.appraisalType===1" :data="appraiseModeData[1]" @refreshMode="handleRefreshMode" :operateType="operateType" :isPublished="isPublished"/>
          </template>
        </yxt-form-item>

        <!-- 选择鉴定人 -->
        <yxt-form-item v-if="config.person" :label="config.person.name || $t('pc_ulcd_lbl_hwtipcontent')" prop="roles">
           <yxt-checkbox-group v-model="ruleForm.roles" @change="handleChangePerson">
              <yxt-checkbox v-for="item in appraisePersons" :key="item.value" :label="item.value" class="yxt-biz-appraise-check">{{item.label}}</yxt-checkbox>
            </yxt-checkbox-group>
            <div class="yxtbiz-appraise-choose-person" v-show="identifyPerson">
              <yxt-select
                v-model="stuList"
                multiple
                :placeholder="$t('pc_biz_appraise_select_person' /*请选择鉴定人*/)"
                icon-name="more"
                hidden-option
                value-key="id"
                prop-label="fullname"
                @visible-change="selectStudents"
              >
                <!--                @remove-tag="handleRemovePerson"-->
                <template slot='tag' slot-scope='{ data }'>
                  <yxtbiz-user-name :name="data.value.fullname" />
                </template>
              </yxt-select>
            </div>
        </yxt-form-item>
      </yxt-form>
      <!--      取消/确定按钮-->
      <div slot="footer">
          <yxt-button plain @click="beforeCloseHandle">{{$t('pc_biz_utility_btn_cancel' /*取消*/)}}</yxt-button>
          <yxt-button type='primary' @click="submitHandle">{{$t('pc_biz_ote_btn_confirm' /*确定*/)}}</yxt-button>
        </div>
    </yxt-drawer>
    <!--    添加指定人抽屉-->
    <add-student-drawer ref="add-student" @chooseAssigner="handleChooseAssigner" :data="stuList" :is-group="!!groupOrgFlag"/>
  </div>
</template>

<script>
import appraiseMode from './components/appraiseMode.vue';
import addStudentDrawer from './components/addStudentDrawer';
import sliderBar from './components/sliderBar';
import {postUdpUsers } from './service';

export default {
  name: 'YxtbizNewUlcdIdentify',
  props: {
    // 与ulcd交互数据
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    orgId: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: String,
      default: '960px'
    },
    operateType: {
      type: Number,
      default: 1
    },
    pagePropertyConfig: {
      type: Object,
      default: () => {return {};}
    },
    bizComponentConfig: { type: Object,
      default: () => {return {};}
    },
    transparentData: {
      type: Object,
      default: () => {return {};}
    }, // 透传配置
    appCode: { type: String, default: '' }, // 业务来源
    taskInfo: { type: Object, default: () => {return {};} },
    taskBase: { type: Object, default: () => {return {};} },
    isPublished: { type: Number, default: 0 }, // 是否为已发布状态
    groupOrgFlag: { type: Number, default: 0 }, // 当前ULCD环境是否为集团版环境，0-否 1-是，默认为0
    taskVersion: { type: String, default: '' },
    loading: {type: Boolean, default: false}
  },
  components: {
    appraiseMode,
    sliderBar,
    addStudentDrawer
  },
  data() {
    return {
      direction: 'rtl',
      AppID: 'identifyAppId', // appId-传到ulcd,目前为自定义
      bizData: { meta: { taskId: '', taskVersion: '' },
        taskInfo: {},
        taskBase: {}
      },
      ruleForm: {
        name: '',
        type: 21, // ulcd-鉴定type:21
        groupOrgFlag: this.groupOrgFlag,
        description: '',
        finishStandard: 1,
        appraisalType: 0,
        roles: [0],
        autoPass: undefined,
        passRate: 60,
        passScore: 60,
        startTime: '',
        endTime: '',
        times: ['', ''],
        template: undefined,
        templateId: '',
        templateName: '',
        appointedUserIds: []
      },
      rules: {
        name: [{ required: true, pattern: this.NotEmptyWithSpace, message: this.$t('pc_biz_appraise_input_appraisalName'), trigger: 'blur' }],
        finishStandard: [{ required: true, message: this.$t('pc_biz_appraise_choose_finish_status'), trigger: 'change' }],
        appraisalType: [{ required: true, message: this.$t('pc_ulcd_msg_nameempty'), trigger: 'blur' }],
        template: [{ required: true, message: this.$t('pc_biz_appraise_template' /* 请选择模板*/), trigger: ['blur', 'change'] }],
        roles: [{ required: true, message: this.$t('pc_biz_appraise_select_person' /* 请选择鉴定人*/), trigger: ['blur', 'change'], validator: this.validatorRole }],
        times: [{type: 'string', trigger: 'blur', validator: this.validateEndTime}]
      },
      // 内容配置-用于新ulcd
      config: {
        name: {
          name: this.$t('pc_biz_appraise_appraisalName' /* 鉴定名称 */),
          placeholder: this.$t('pc_biz_appraise_input_appraisalName' /* 请输入鉴定名称*/)
        },
        subTime: {
          name: this.$t('pc_biz_appraise_apply_time' /* 申请时间*/)
        },
        tips: {
          name: this.$t('pc_biz_appraise_description' /* 鉴定说明 */),
          placeholder: this.$t('pc_biz_appraise_input_description' /* 请输入鉴定说明*/)
        },
        principle: {
          name: this.$t('pc_biz_appraise_finish_status' /* 完成标准*/)
        },
        type: {
          name: this.$t('pc_biz_appraise_type' /* 鉴定方式 */)
        },
        query: {
          name: this.$t('pc_biz_appraise_select_questionnaire' /* 选择问卷*/)
        },
        person: {
          name: this.$t('pc_biz_appraise_choose_person' /* 选择鉴定人*/)
        }
      },
      // 完成标准-选项
      finishStandardOptions: [{value: 1, label: this.$t('pc_biz_appraise_finish_status_task' /* 鉴定合格算完成任务 */)}, {value: 0, label: this.$t('pc_biz_appraise_finish_status_apply' /* 学员申请鉴定算完成任务 */)}],
      // 鉴定方式-选项
      appraiseModeData: [{type: 1, autoPass: false, num: 60, template: undefined}, {type: 2, autoPass: false, num: 60, template: undefined}],
      // 鉴定方式-查看事例-值
      appraiseExample: {radio1: 1, radio2: 1, mark1: 3, mark2: 6},
      // 选择鉴定人-选项
      appraisePersons: [{label: this.$t('pc_biz_appraise_tutor_only' /* 带教导师*/), value: 0},
        {label: this.$t('pc_biz_appraise_manager_only' /* 直属经理 */), value: 1},
        {label: this.$t('pc_biz_appraise_dep_manage' /* 部门经理 */), value: 2},
        {label: this.$t('pc_biz_appraise_coach' /* 培训辅导员 */), value: 3},
        {label: this.$t('pc_biz_appraise_assigner' /* 指定人 */), value: 4}],
      // 选择鉴定人-自定义
      stuList: [],
      selectedData: {
        type: Object,
        require: true,
        validator: value => typeof value === 'object' && value.unselectedList instanceof Array && value.selectedList instanceof Array,
        default: () => ({
          unselectedList: [], // 未选中学员 for backend
          selectedList: [], // 选中的学员数量
          chosenStudentNumber: 0, // 选中的学员数量
          backEndAllChecked: false // 全选标志 for backend
        })
      },
      NotEmptyWithSpace: /\S/, //  非空正则校验, 纯空格表示空
      identifyPerson: false
    };
  },
  computed: {
    // 鉴定-弹出框
    drawerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible: {
      handler(nval, oval) {
        if (nval === true) {
          this.bizData.meta = { taskId: this.AppID, taskVersion: this.taskVersion };
          // 编辑内容回显
          if (this.operateType === 2) {
            let ruleForm = JSON.parse(JSON.stringify(this.taskBase));
            Object.assign(this.ruleForm, ruleForm);
            this.ruleForm.times = [ruleForm.startTime || '', ruleForm.endTime || ''];
            this.ruleForm.roles = ruleForm.roles || [];
            this.identifyPerson = !!(ruleForm.roles && ruleForm.roles.includes(4));
            this.appraiseModeData.map((item, index)=>{
              this.appraiseModeData[index] = ruleForm.appraisalType === index
                ? {autoPass: !!ruleForm.autoPass, template: {id: ruleForm.templateId, name: ruleForm.templateName}, num: index ? ruleForm.passScore : ruleForm.passRate, type: item.type }
                : {autoPass: false, template: undefined, num: index ? ruleForm.passScore : ruleForm.passRate, type: item.type};
            });
            this.$nextTick(()=>{
              this.$refs['appraiseMode'] && this.$refs['appraiseMode'].open(this.appraiseModeData[ruleForm.appraisalType]);
            });
            if (ruleForm.appointedUserIds && ruleForm.appointedUserIds.length) {
              postUdpUsers({orgId: this.orgId, ids: ruleForm.appointedUserIds}).then(res=>{
                if (res) {
                  this.stuList = JSON.parse(JSON.stringify(res));
                }
              });
            }
          }
          // 如果发布则禁用相关配置项目
          if (this.isPublished) {
            let isPublished = {};
            Object.keys(this.ruleForm).forEach((key) => {
              const val = this.pagePropertyConfig[key];
              if (val && val['publishedDisable']) {
                isPublished[key] = true;
              }
            });
          }
        } else {
          this.resetForm();
          this.setPageConfig();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.setPageConfig();
  },
  methods: {
    // 申请日期rules
    validateEndTime(rule, value, callback) {
      if (value && value.length && value[1] && new Date().getTime() > new Date(value[1]).getTime()) {
        callback(new Error(this.$t('pc_biz_appraise_close_time' /* 结束时间需大于当前时间*/)));
      } else {
        callback();
      }
    },
    // 鉴定人rules
    validatorRole(rule, value, callback) {
      let roleInfo = this.ruleForm.roles.join(',');
      if (!roleInfo) {
        callback(new Error(this.$t('pc_biz_appraise_select_person' /* 请选择鉴定人*/)));
      } else {
        // 选择鉴定人为指定人且没有选择人员
        if (roleInfo.includes('4') && (!this.stuList || this.stuList.length === 0)) {
          callback(new Error(this.$t('pc_biz_appraise_select_person' /* 请选择鉴定人*/)));
        } else {
          callback();
        }
      }
    },
    // 打开选择鉴定人-指定人抽屉
    selectStudents() {
      this.$refs['add-student'].init({ ...this.selectedData });
    },
    // 待传到ulcd的数据格式化
    getBizData() {
      let bizData = JSON.parse(JSON.stringify(this.bizData));
      let activeTypeData = this.appraiseModeData[this.ruleForm.appraisalType];
      console.log(this.ruleForm.times);
      let ruleForm = {...this.ruleForm,
        autoPass: activeTypeData.autoPass,
        templateId: activeTypeData.template && activeTypeData.template.id,
        templateName: activeTypeData.template && activeTypeData.template.name,
        passRate: this.appraiseModeData[0].num,
        passScore: this.appraiseModeData[1].num,
        startTime: (this.ruleForm.times && this.ruleForm.times[0]) || '',
        endTime: (this.ruleForm.times && this.ruleForm.times[1]) || ''
      };
      if (this.ruleForm.roles.includes(4)) {
        let selectPersons = this.stuList;
        if (selectPersons && selectPersons.length) {
          ruleForm.appointedUserIds = selectPersons.map(item=>item.id);
        }
      } else {
        ruleForm.appointedUserIds = [];
      }
      bizData.taskBase = ruleForm;
      return bizData;
    },
    // 确定
    submitHandle() {
      // 鉴定方式子组件校验
      const result = this.$refs['appraiseMode'].validateHandle();
      this.$refs['ruleForm'].validate((valid) => {
        if (valid && result) {
          let bizData = this.getBizData();
          this.$emit('submitHandle', bizData, this.transparentData);
          this.drawerVisible = false;
        } else {
          this.$message({
            type: 'error',
            message: this.$t('pc_biz_ote_msg_checkinput')
          });
          return false;
        }
      });
    },
    cancelHandle() { // 业务数据，可为null
      let bizData = this.getBizData();
      this.$emit('cancelHandle', bizData, this.transparentData);
    },
    draftSaveHandle() { // 业务数据
      let bizData = this.getBizData();
      this.$emit('draftSaveHandle', bizData, this.transparentData);
    },
    // 鉴定取消事件
    beforeCloseHandle() {
      let hasValue = false;
      for (let key in this.ruleForm) {
        let val = this.ruleForm[key];
        switch (Object.prototype.toString.call(val)) {
          case '[object String]' :
            if (val !== '') { hasValue = true; } break;
          case '[object Boolean]]' :
            if (val) { hasValue = true; } break;
          case '[object Array]]' :
            if (val.length > 0) { hasValue = true; } break;
        }
      }
      // 如果编辑过有草稿
      if (hasValue) {
        // 这里弹框
        this.$confirm(this.$t('pc_biz_appraise_alram_should_close' /* 当前操作尚未保存，是否确认取消？*/), this.$t('pc_biz_group_cancel_title' /* 确认取消*/), {type: 'warning'})
          .then(_ => {
            this.draftSaveHandle();
            this.drawerVisible = false;
          });
      } else {
        this.cancelHandle();
        this.drawerVisible = false;
      }
    },
    setPageConfig() {
      const keys = Object.keys(this.pagePropertyConfig);
      keys.forEach((key) => {
        const val = this.pagePropertyConfig[key];
        const { name, required, showState, otherName, otherNameInternalKey } = val;
        this.config[`${key}ShowState`] = showState;
        this.config[key] = (otherNameInternalKey && this.$t(otherNameInternalKey)) || otherName || name;
        this.rules[key][0]['required'] = Boolean(required);
        this.ruleForm[key] = val['defVal'];
      });
    },
    resetForm() {
      if (this.$refs['ruleForm'] && typeof this.$refs['ruleForm'].resetFields === 'function') {
        this.$refs['ruleForm'].resetFields();
        this.stuList = [];
        this.selectedData.selectedList = [];
        this.identifyPerson = false;
        this.appraiseModeData = [{type: 1, autoPass: false, num: 60, template: undefined}, {type: 2, autoPass: false, num: 60, template: undefined}];
      }
      this.$nextTick(() => {
        this.$refs['appraiseMode'] && this.$refs['appraiseMode'].open({type: 1, autoPass: false, num: 60, template: undefined});
      });
    },
    handleChooseAssigner(value) {
      this.stuList = value;
      this.selectedData.selectedList = this.stuList;
      this.selectedData.chosenStudentNumber = this.stuList.length;
    },
    // 切换鉴定方式
    handleChangeType(value) {
      this.$nextTick(()=>{
        this.$refs['appraiseMode'].open(this.appraiseModeData[value]);
      });
    },
    // 鉴定方式组件内容回传
    handleRefreshMode(data) {
      this.appraiseModeData[data.type - 1] = data;
    },
    handleRemovePerson(value) {
      if (value) {
        let index = this.stuList.findIndex(function(item) {
          if (item.id === value.id) {
            return true;
          }
        });
        console.log(index);
        if (index > -1) {
          this.stuList.splice(index, 1);
        }
      }
    },
    handleChangePerson(val) {
      console.log(val);
      if (val && val.includes(4)) {
        this.$refs['ruleForm'].clearValidate('roles');
        this.identifyPerson = true;
      } else {
        this.identifyPerson = false;
      }
    }
  }
};
</script>
